import { render, staticRenderFns } from "./GoodsDetails.vue?vue&type=template&id=333ca71a"
import script from "./GoodsDetails.vue?vue&type=script&lang=js"
export * from "./GoodsDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetails.vue?vue&type=style&index=0&id=333ca71a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports